import { render } from "./mapbox.vue?vue&type=template&id=4b1c2d22&scoped=true"
import script from "./mapbox.vue?vue&type=script&lang=ts"
export * from "./mapbox.vue?vue&type=script&lang=ts"

import "./mapbox.vue?vue&type=style&index=0&id=4b1c2d22&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4b1c2d22"

export default script